import Schema from 'async-validator';
import entryMixin from '../../assets/mixins/entry';
import langs from '../../assets/locale/lang/address';
import { showToast } from '../../assets/utils/toast';

/** 编辑类型 */
const AddressSaveType = {
  Add: 'add',
  Edit: 'edit'
};

export default {
  langs,
  mixins: [entryMixin],
  props: {
    /** 地址管理 sdk 实例 */
    addressManagementSdk: Object,
    /** 保存类型 */
    saveType: {
      type: String,
      validator: (val) => {
        return Object.values(AddressSaveType).includes(val);
      },
      default: AddressSaveType.Add
    }
  },

  data() {
    return {
      /** 校验器 */
      _validator: null,
      formData: this.generateDefaultFormData(),
      /** 表单错误 */
      formError: null,
    };
  },

  mounted() {
    this._validator = new Schema(this.formDescriptor);
  },

  beforeDestroy() {
    this._validator = null;
  },

  computed: {
    formDescriptor() {
      return {
        name: { type: 'string', required: true, whitespace: true, message: this.iarTrans('address.namePlaceholder') },
        mobile: [
          { type: 'string', required: true, message: this.iarTrans('address.mobilePlaceholder') },
          { pattern: /^1[3-9]\d{9}$/, message: this.iarTrans('address.mobileFormatError') }
        ],
        area: { type: 'string', required: true, message: this.iarTrans('address.areaPlaceholder') },
        address: { type: 'string', required: true, message: this.iarTrans('address.addressPlaceholder') },
      };
    },
    /** 格式化地区字符串 */
    formatedAreaStr() {
      return this.formData.area?.split('/').join('');
    }
  },

  methods: {
    /**
     * @description: 生成默认表单数据
     * @return {object}
     */
    generateDefaultFormData() {
      return {
        name: '',
        mobile: '',
        area: '',
        address: ''
      };
    },
    /**
     * @description: 设置表单的值
     * @param {object} values
     * @return {void}
     */
    setFieldsValue(values) {
      this.formData = {
        ...this.formData,
        ...values
      };
    },
    /**
     * @description: 重置表单
     * @return {void}
     */
    resetFields() {
      this.formData = this.generateDefaultFormData();
    },
    /**
     * @description: 验证整个表单
     * @return {object}
     */
    async validate() {
      try {
        const data = await this._validator.validate(this.formData);
        this.formError = null;
        return JSON.parse(JSON.stringify(data));
      } catch ({ errors, fields }) {
        this.formError = fields;
        throw new Error({ errors, fields });
      }
    },
    /**
     * @description: 设置区域
     * @param {string} value
     * @return {void}
     */
    setAddressArea(value) {
      this.formData.area = value;
    },
    /**
     * @description: 区域 tab点击
     * @return {void}
     */
    handleAreaClick() {
      this.$emit('click-area', this.formData.area);
    },
    /**
     * @description: 保存
     * @return {void}
     */
    async handleSave(event) {
      event.preventDefault();
      if (!this.addressManagementSdk) return;
      if (this.saveType === AddressSaveType.Edit) {
        this.updateAddress();
      } else {
        this.addAddress();
      }
    },
    /**
     * @description: 添加新地址
     * @return {void}
     */
    async addAddress() {
      const formData = await this.validate();
      try {
        const res = await this.addressManagementSdk.addAddress(formData);
        showToast({ text: this.iarTrans('address.saveSuccess') });
        this.$emit('save', res, this.saveType);
      } catch (error) {
        showToast({ text: this.iarTrans('address.saveError') });
        throw error;
      }
    },
    /**
     * @description: 修改地址
     * @return {void}
     */
    async updateAddress() {
      if (!this.formData.id) {
        // 提示
        showToast({ text: 'address.error' });
        return;
      }
      const formData = await this.validate();
      try {
        await this.addressManagementSdk.updateAddress(formData);
        showToast({ text: this.iarTrans('address.editSuccess') });
        this.$emit('save', formData, this.saveType);
      } catch (error) {
        showToast({ text: this.iarTrans('address.editError') });
        throw error;
      }
    },
    handleFocus(e) {
      e.target && e.target.scrollIntoView();
      this.$emit('address-edit-focus');
    },
    handleBlur() {
      this.$emit('address-edit-blur');
    }
  }
};
